import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../LanguageProvider";
import Header from "../Reutilizables/Header/Header";
import Footer from "../Reutilizables/Footer/Footer";
import Hero from "../Reutilizables/Hero/Hero";
import ataLogo from "../../assets/image-removebg-preview.png";
import atifLogo from "../../extras/atifAssoc.png";
import womenOwnedLogo from "../../assets/women-owned-removebg-preview.png";
import "./Home.css";

const serviceItems = [
  { icon: "bi-people", titleKey: "servicesTextTitle2", textKey: "servicesText2" },
  { icon: "bi-mic", titleKey: "servicesTextTitle1", textKey: "servicesText1" },
  { icon: "bi-file-earmark-text", titleKey: "servicesTitleTranslation", textKey: "servicesTextTranslation" },
  { icon: "bi-eye", titleKey: "servicesTextTitle3", textKey: "servicesText3" },
  { icon: "bi-ear", titleKey: "servicesTextTitle4", textKey: "servicesText4" },
  { icon: "bi-headphones", titleKey: "servicesTextTitle5", textKey: "servicesText5" },
];

const highlightUSCIS = (text) => text.split(/(USCIS)/g).map((part, index) => (
  part === "USCIS"
    ? <strong className="testimonial-card__highlight" key={index}>{part}</strong>
    : part
));

function Home() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const testimonials = language === "en"
    ? [
        ["Her patience and professionalism. Would I recommend Language Hero to other people? Yes, definitely.", "Ramona Lopez", "USCIS Interview · South Florida"],
        ["The kindness and professionalism. Would I recommend Language Hero to other people? Yes, definitely.", "María Alejandra", "USCIS Interview · South Florida"],
        ["I valued her professionalism, preparation and support during my USCIS interview. She made me feel safe, explained everything clearly, and made a stressful experience calmer. Elegant, attentive and highly recommended.", "Aldana Moreno", "USCIS Interview · South Florida"],
      ]
    : [
        ["Su paciencia y profesionalismo. ¿Recomendaría Language Hero a otras personas? Sí, definitivamente.", "Ramona Lopez", "Entrevista de USCIS · Sur Florida"],
        ["La amabilidad y profesionalismo. ¿Recomendaría Language Hero a otras personas? Sí, definitivamente.", "María Alejandra", "Entrevista de USCIS · Sur Florida"],
        ["Valoré su profesionalismo, preparación y acompañamiento durante mi entrevista de USCIS. Me hizo sentir segura, explicó todo con claridad y convirtió una experiencia estresante en una mucho más tranquila. Elegante, atenta y totalmente recomendable.", "Aldana Moreno", "Entrevista de USCIS · Sur Florida"],
      ];

  return (
    <div className="app-shell home-page">
      <Header />
      <main className="page-main">
        <Hero className="home-hero">
          <div className="home-hero__content">
            <h1>
              {language === "en" ? (
                <>Professional<br />Interpretation and<br />Translation Services</>
              ) : (
                <>Servicios profesionales<br />de interpretación y<br />traducción</>
              )}
            </h1>
            <span className="home-hero__accent" />
            <h2>
              {language === "en" ? (
                <>On-site and remote language services for <span className="home-hero__highlight">individuals,</span> <span className="home-hero__highlight">businesses</span> and <span className="home-hero__highlight">organizations.</span></>
              ) : (
                <>Servicios lingüísticos presenciales y remotos para <span className="home-hero__highlight">particulares,</span> <span className="home-hero__highlight">empresas</span> y <span className="home-hero__highlight">organizaciones.</span></>
              )}
            </h2>
            <div className="home-hero__actions">
              <Link className="button-secondary" to="/services">{t("exploreServices")}</Link>
            </div>
            <div className="home-certifications" aria-label="Certifications and memberships">
              <a href="https://www.atanet.org/" target="_blank" rel="noopener noreferrer"><img src={ataLogo} alt="American Translators Association" /></a>
              <a href="https://atifonline.org/" target="_blank" rel="noopener noreferrer"><img src={atifLogo} alt="Association of Translators and Interpreters of Florida" /></a>
              <a className="women-owned-logo" href="https://www.wbenc.org/certification/certification-eligibility/" target="_blank" rel="noopener noreferrer"><img src={womenOwnedLogo} alt="Women-Owned Business"/>
              </a>
            </div>
          </div>
        </Hero>

        <section className="testimonials-section">
          <div className="lh-container">
            <h2 className="home-section-heading">{language === "en" ? "WHAT OUR CLIENTS SAY" : "LO QUE DICEN NUESTROS CLIENTES"}</h2>
            <div className="home-heading-ornament"><span />★<span /></div>
            <div className="testimonial-grid">
              {testimonials.map(([quote, name, meta]) => (
                <article className="testimonial-card" key={name}>
                  <div className="testimonial-card__quote">“</div>
                  <p>{highlightUSCIS(quote)}</p>
                  <div className="testimonial-card__stars" aria-label="5 stars">★★★★★</div>
                  <div className="testimonial-card__person">
                    <span className="testimonial-card__avatar"><i className="bi bi-person-fill" /></span>
                    <div><strong>{name}</strong><span>{highlightUSCIS(meta)}</span></div>
                  </div>
                </article>
              ))}
            </div>
            <div className="experience-link">
              <i className="bi bi-heart-fill" />
              <span>{language === "en" ? "Have you worked with us?" : "¿Has trabajado con nosotros?"}</span>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSeOIm-2a8cHUDaaD2Ja0wjY_F08i_PcsYBaFKW5zdlp-hfLCA/viewform?usp=preview" target="_blank" rel="noopener noreferrer">
                {language === "en" ? "Share your experience →" : "Comparte tu experiencia →"}
              </a>
            </div>
          </div>
        </section>

        <section className="home-services-section">
          <div className="lh-container">
            <h2 className="home-section-heading">{language === "en" ? "OUR SERVICES" : "NUESTROS SERVICIOS"}</h2>
            <div className="service-strip">
              {serviceItems.map((item) => (
                <article className="service-strip__item" key={item.titleKey}>
                  <div className="service-strip__heading">
                    <i className={`bi ${item.icon}`} aria-hidden="true" />
                    <h3>{t(item.titleKey)}</h3>
                  </div>
                  <p>{t(item.textKey)}</p>
                </article>
              ))}
            </div>
            <Link className="home-services-link" to="/services">{t("exploreAllServices")} →</Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Home;
